const getStringLengthInPixels = (value, fontSize = 16) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");
    ctx.font = `${fontSize}px Proxima Nova`
    return ctx.measureText(value).width;
} 

export default getStringLengthInPixels